import React, { useContext } from 'react';
import { MultiPortfolioReviewContext } from '../common/MultiPortfolioReviewContext';
import { hasUnmatchedFunds, hasUnassignedInvestments } from '../../review/helpers';
import styled from 'styled-components';
import { ErrorMessage } from '../../../components/page-parts';
import { useHasFF } from 'venn-utils';
import { cn } from '@/lib/utils';
import { Icon } from 'venn-ui-kit';

const NEEDS_MAPPING_INVESTMENTS_MESSAGE =
  'Some investment names/tickers/ISIN could not be matched to an investment in the Data Library. Please review below and ensure all investments are mapped in order to continue.';

const NEEDS_MAPPING_AND_STRATEGIES_MESSAGE =
  'Some investment names/tickers/ISIN/CUSIP could not be matched to an investment in the Data Library. Please review below and ensure all investments are mapped and assigned to a strategy in order to continue.';

export const ErrorBanner = () => {
  const hasRCMStrategyEnforcement = useHasFF('rcm_strategy_enforcement_ff');

  const {
    data: { parsedResults, selectedIndex, strategyData },
  } = useContext(MultiPortfolioReviewContext);
  const openedPortfolio = parsedResults[selectedIndex]!.parsedPortfolio;
  const excludedInvestments = parsedResults[selectedIndex]!.excludedInvestments;

  if (hasUnmatchedFunds(openedPortfolio, excludedInvestments)) {
    return (
      <StyledErrorMessage data-testid="unmapped-investments-error">
        {hasRCMStrategyEnforcement ? NEEDS_MAPPING_AND_STRATEGIES_MESSAGE : NEEDS_MAPPING_INVESTMENTS_MESSAGE}
      </StyledErrorMessage>
    );
  }

  if (hasRCMStrategyEnforcement && hasUnassignedInvestments(openedPortfolio, excludedInvestments, strategyData)) {
    return (
      <StyledErrorMessage data-testid="unmapped-investments-error">
        {NEEDS_MAPPING_AND_STRATEGIES_MESSAGE}
      </StyledErrorMessage>
    );
  }

  return (
    <div className={cn('text-white bg-venn-green p-[7.5px] pl-[15px] pr-[7.5px]')} data-testid="no-errors-message">
      <Icon type="check" /> All investments and strategies mapped to the Data Library.
    </div>
  );
};

const StyledErrorMessage = styled(ErrorMessage)`
  margin-top: 0;
`;
